import React, { useState } from 'react';
import { CardNumberElement,CardExpiryElement,CardCvcElement, useStripe, useElements } from '@stripe/react-stripe-js';
import {  Form, Button } from "react-bootstrap";
import loader from '../../assests/loader.gif';
import API from '../../Utils/Api';
import { gettoastwarning } from '../../Utils/Common';
import { useNavigate } from "react-router-dom";

const CheckoutForm = ({ inputs, member, inputsche }) => {
	const navigate = useNavigate();
  const [loading,setLoading] = useState(false);
  const stripe = useStripe();
  const elements = useElements();
  
const handleSubmit = async (e) => {
    e.preventDefault();
 
    if (!stripe || !elements) return;
 
    setLoading(true);
 
    try {
        const unq_id = localStorage.getItem('device_id');
        
        // Check if the order is still valid
        let formData1 = new FormData();
        formData1.append('event_id', inputs.event_id);
        formData1.append('unq_id', unq_id);
 
        const checkResponse = await API.post('check_order_is_valid_or_not_for_web', formData1);
 
        if (checkResponse.data.status === false) {
            setLoading(false);
            const u_link = `/event-product/${inputs.event_id}`;
            gettoastwarning('Your booking has been expired. Please try to book again.', u_link);
            return;
        }
 
        // Prepare tickets data
        const allNewMembers = member.map((val) => ({
            ticket_id: val.ticket_id,
            price: val.booking_price,
            qty: 1,
            fees_percentage: val.fees_percentage,
            vat_percentage: val.vat_percentage,
            total_fees: val.total_fees,
            total_vat: val.total_vat,
            user_id: 0,
            first_name: val.first_name,
            last_name: val.last_name,
            email: val.email,
            mobile_number: val.phone_number,
            country_code: val.country_code,
            age: val.age,
            question: val.question.map(innerItem => ({
                id: innerItem.id,
                question_type: innerItem.type,
                option_id: innerItem.option_val,
                answer: innerItem.answer_text
            }))
        }));
 
        // Create payment intent
        let formData = new FormData();
        formData.append('amount', inputs.grand_total);
        formData.append('event_id', inputs.event_id);
        formData.append('stripe_token', 'ffff');
        formData.append('email', inputsche.email);
        formData.append('first_name', inputsche.first_name);
        formData.append('last_name', inputsche.last_name);
        formData.append('tickets', JSON.stringify(allNewMembers));
        formData.append('subtotal', inputs.sub_total);
        formData.append('totalfees', inputs.total_fees);
        formData.append('totalvat', inputs.total_vat);
        formData.append('grand_total', inputs.grand_total);
        formData.append('promo_code_used', 0);
        formData.append('promo_code_id', 0);
        formData.append('promo_code_percentage', 0);
        formData.append('promo_code_discount', 0);
        formData.append('unq_id', ''); // If you meant to send unq_id, use formData.append('unq_id', unq_id);
        formData.append('type', 'Web');
 		formData.append('is_newsletter', inputsche.single_event ? 1 : 0);
 		formData.append('tax_type', inputs.tax_type);
 		formData.append('symbol', inputs.symbol);
 		formData.append('currency', inputs.currency);
		if(inputsche.single_event)
		{
			formData.append('mobile_number', inputsche.mobile_number);
			formData.append('location', inputsche.location);
			formData.append('location_name', inputsche.location_name);
			formData.append('gender', inputsche.gender);
			formData.append('birth_year', inputsche.birth_year);
		}
        const paymentIntentResponse = await API.post('create_payment_intent_for_web', formData);
 
        if (paymentIntentResponse.data.status === false) {
            setLoading(false);
            gettoastwarning(paymentIntentResponse.data.message, '');
            return;
        }
 
        const clientSecret = paymentIntentResponse.data.data.clientSecret;
 
        // Confirm the payment
        const result = await stripe.confirmCardPayment(clientSecret, {
            payment_method: {
                card: elements.getElement(CardNumberElement),
                billing_details: {
                    name: `${inputsche.first_name} ${inputsche.last_name}`,
                    email: inputsche.email,
                },
            },
        });
 
        if (result.error) {
            PaymentIntentFail(paymentIntentResponse.data.data.paymentIntentId, result.error.message);
            setLoading(false);
            gettoastwarning(result.error.message, '');
        } else {
            pay(paymentIntentResponse.data.data.paymentIntentId);
        }
 
    } catch (error) {
		setLoading(false);
        console.error(error);
		var msg='Payment Intent: '+error.message;
        gettoastwarning(msg, '');
    } finally {
        //setLoading(false);
    }
};
  /*const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;

    setLoading(true);

   let unq_id = localStorage.getItem('device_id');
		let formData1 = new FormData(); 
		formData1.append('event_id', inputs.event_id);
		formData1.append('unq_id', unq_id);
		API.post('check_order_is_valid_or_not_for_web',formData1)
			.then(response => {
			if(response.data.status === false){
				setLoading(false);
				var u_link='/event-product/'+inputs.event_id;
				gettoastwarning('Your booking has been expired. Please try to book again.',u_link);
			}else{

				 const allNewMembers2 = [];
					member.forEach((val) => {
							const newMember = {
							  ticket_id: val.ticket_id,
							  price:val.booking_price,
							  qty:1,
							  fees_percentage:val.fees_percentage,
							  vat_percentage:val.vat_percentage,
							  total_fees:val.total_fees,
							  total_vat: val.total_vat,
							  user_id:0,
							  first_name: val.first_name,
							  last_name: val.last_name,
							  email: val.email,
							  mobile_number: val.phone_number,
							  country_code: val.country_code,
							  age: val.age,
							  question:val.question.map(innerItem => ({ id: innerItem.id, question_type: innerItem.type,option_id:innerItem.option_val,answer:innerItem.answer_text}))
							};
							allNewMembers2.push(newMember);
					});

							let formData = new FormData(); 
							
							formData.append('amount', inputs.grand_total);
							formData.append('event_id', inputs.event_id);
					
							formData.append('stripe_token', 'ffff');
							formData.append('email', inputsche.email);
							formData.append('first_name', inputsche.first_name);
							formData.append('last_name', inputsche.last_name);
							formData.append('tickets', JSON.stringify(allNewMembers2));
							formData.append('subtotal', inputs.sub_total);
							formData.append('totalfees', inputs.total_fees);
							formData.append('totalvat', inputs.total_vat);
							formData.append('grand_total', inputs.grand_total);
							formData.append('promo_code_used', 0);
							formData.append('promo_code_id', 0);
							formData.append('promo_code_percentage', 0);
							formData.append('promo_code_discount', 0);
							formData.append('unq_id', '');
							formData.append('type', 'Web');
							API.post('createPaymentIntent', formData)
								.then(async response => {
									
								if(response.data.status === false){
									setLoading(false);
									gettoastwarning(response.data.message,'');
								}else{
									var clientSecret=response.data.data.clientSecret;
								   	const result = await stripe.confirmCardPayment(clientSecret, {
										  payment_method: {
											card: elements.getElement(CardNumberElement),
											billing_details: {
											  name:inputsche.first_name + ' '+ inputsche.last_name,
											  email: inputsche.email,
											},
										  },
										});

										if (result.error) {
										//console.log(result);
											PaymentIntentFail(result.payment_intent.id,result.message);
						            setLoading(false);
						            gettoastwarning(result.error.message, '');
						        } else {
						            // Payment succeeded
						            pay(result.paymentIntent.id);
						        }
								}                  
							}).catch(error => {
								
								setLoading(false);
								 gettoastwarning('Something went wrong. Please try again later.','');
							});
						} 
					}).catch(error => {
						console.log(error);
				setLoading(false);
				 gettoastwarning('Something went wrong. Please try again later.','');
			});
  };*/
  function PaymentIntentFail(intent_id,message){
  		 let formData = new FormData(); 
			formData.append('intent_id', intent_id);
			formData.append('message', message);
			API.post('payment_failed', formData)
				.then(response1 => {
					
				if(response1.data.status === false){
					
				}else{
				   
				}                  
			}).catch(error => {
				
			}); 
  }
  function pay(intent_id){
	  
	  /*let unq_id = localStorage.getItem('device_id');
		let formData1 = new FormData(); 
		formData1.append('event_id', inputs.event_id);
		formData1.append('unq_id', unq_id);
		API.post('check_order_is_valid_or_not_for_web',formData1)
			.then(response => {
			if(response.data.status === false){
				setLoading(false);
				var u_link='/event-product/'+inputs.event_id;
				gettoastwarning('Your booking has been expired. Please try to book again.',u_link);
			}else{*/
				  const allNewMembers = [];
					member.forEach((val) => {
							const newMember = {
							  ticket_id: val.ticket_id,
							  price:val.booking_price,
							  qty:1,
							  fees_percentage:val.fees_percentage,
							  vat_percentage:val.vat_percentage,
							  total_fees:val.total_fees,
							  total_vat: val.total_vat,
							  user_id:0,
							  first_name: val.first_name,
							  last_name: val.last_name,
							  email: val.email,
							  mobile_number: val.phone_number,
							  country_code: val.country_code,
							  age: val.age,
							  question:val.question.map(innerItem => ({ id: innerItem.id, question_type: innerItem.type,option_id:innerItem.option_val,answer:innerItem.answer_text}))
							};
							allNewMembers.push(newMember);
					});
				  let formData = new FormData(); 
					formData.append('event_id', inputs.event_id);
					formData.append('subtotal', inputs.sub_total);
					formData.append('totalfees', inputs.total_fees);
					formData.append('totalvat', inputs.total_vat);
					formData.append('grand_total', inputs.grand_total);
					formData.append('stripe_token', 'ffff');
					formData.append('email', inputsche.email);
					formData.append('first_name', inputsche.first_name);
					formData.append('last_name', inputsche.last_name);
					formData.append('tickets', JSON.stringify(allNewMembers));
					formData.append('promo_code_used', 0);
					formData.append('promo_code_id', 0);
					formData.append('promo_code_percentage', 0);
					formData.append('promo_code_discount', 0);
					formData.append('unq_id', '');
					formData.append('intent_id', intent_id);
					formData.append('is_newsletter', inputsche.single_event ? 1 : 0);
					formData.append('tax_type', inputs.tax_type);
 					formData.append('symbol', inputs.symbol);
 					formData.append('currency', inputs.currency);
					if(inputsche.single_event)
					{
						formData.append('mobile_number', inputsche.mobile_number);
						formData.append('location', inputsche.location);
						formData.append('location_name', inputsche.location_name);
						formData.append('gender', inputsche.gender);
						formData.append('birth_year', inputsche.birth_year);
					}
					API.post('order_book_for_web', formData)
						.then(response1 => {
							
						if(response1.data.status === false){
							setLoading(false);
							gettoastwarning(response1.data.message,'');
						}else{
						   var order_number=response1.data.data.order_number;
						   navigate('/order-completed',{ state: { order_number:order_number } });
						}                  
					}).catch(error => {
						 setLoading(false);
						 var msg='Payment: '+error.message;
						 gettoastwarning(msg,'');
					}); 
				/*}                  
			}).catch(error => {
				setLoading(false);
				 gettoastwarning('Something went wrong. Please try again later.','');
			});*/
  }

  return (
    <Form onSubmit={handleSubmit}>
		<div className="row g-3 mb-3">
		  <div className="col-md-12">
		 
			<Form.Group controlId="cardNumber">
			  <Form.Label>Card number</Form.Label>
			  <div className="form-control">
			  <CardNumberElement options={{
				disableLink: true,
				style: {
				  base: {
					lineHeight: '24px', // this affects the height
					'::placeholder': {
					  color: '#6c757d',
					},
				  },
				  invalid: {
					color: '#dc3545',
				  },
				},
			  }} />
			  </div>
			</Form.Group>
		  </div>
		</div>
		<div className="row g-3 mb-3">
		  <div className="col-md-6">
			<Form.Group controlId="expiryDate">
			  <Form.Label>Expiration date</Form.Label>
			  <div className="form-control">
			  <CardExpiryElement options={{
				style: {
				  base: {
					lineHeight: '24px', // this affects the height
					'::placeholder': {
					  color: '#6c757d',
					},
				  },
				  invalid: {
					color: '#dc3545',
				  },
				},
			  }} />
			  </div>
			</Form.Group>
		  </div>
		  <div className="col-md-6">
			<Form.Group controlId="cvv">
			  <Form.Label>CVC/CVV</Form.Label>
			  <div className="form-control ">
			  <CardCvcElement  options={{
				style: {
				  base: {
					lineHeight: '24px', // this affects the height
					'::placeholder': {
					  color: '#6c757d',
					},
				  },
				  invalid: {
					color: '#dc3545',
				  },
				},
  }} />
			  </div>
			</Form.Group>
		  </div>
		</div>
		
		<Button type="submit" className="mt-4 w-100 ne">CONFIRM - {inputs.symbol}{Number(inputs.grand_total).toFixed(2)}</Button>
		{loading && (
	   <div className="loadingClass">
			<img src={loader} alt="loader"/>
		</div>
	   )}
	  </Form>
  );
};

export default CheckoutForm;
